const getters = {
  smOrders: (state) => state.sm_orders,
  smOrderTypes: (state) => state.sm_order_types,
};

export default getters;
